import { style } from "@vanilla-extract/css";
import { calc } from "@vanilla-extract/css-utils";
import { breakpoints, textTruncate } from "../../styles";
import { vars } from "../../styles/theme.css";

export const elementDataContainer = style({
  display: "flex",
  flex: "1",
  flexDirection: "column",
  gap: vars.space["2xs"],
  padding: vars.space.xs,
  overflow: "hidden",
  color: vars.colors.primary,
});

export const elementInTableButton = style({
  width: "100%",
});

export const elementInTable = style({
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: vars.space["2xs"],
});

export const info = style({
  display: "flex",
  gap: vars.space.xs,
  color: vars.colors.onSurfaceVariant,
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.xs,
});

export const elementWebName = style([
  textTruncate,
  {
    display: "inline-block",
    maxWidth: "100%",
    textAlign: "start",
    color: vars.colors.onSurface,
    fontFamily: vars.fonts.bold,
    fontSize: vars.fontSizes.heading.s,
  },
]);

export const iconContainer = style({
  position: "absolute",
  bottom: vars.space.m,
  insetInlineEnd: vars.space.xs,
  display: "flex",
  flexDirection: "column",
  gap: vars.space["2xs"],
  marginBottom: calc.negate(vars.space.s),
  "@media": {
    [`(min-width: ${breakpoints[5]})`]: {
      flexDirection: "row",
    },
  },
});

export const elementIconInTable = style({
  // Flex ensures tooltip buttons fill this fixed-size container correctly.
  // Without it, buttons with vertical-align: middle sit too low (aligns to line box baseline, not container).
  display: "flex",
  width: 12,
  height: 12,
  "@media": {
    [`(min-width: ${breakpoints[5]})`]: {
      width: 16,
      height: 16,
    },
  },
});

export const iconWrapper = style({
  position: "absolute",
  bottom: 0,
  insetInlineEnd: 0,
  "@media": {
    [`(min-width: ${breakpoints[5]})`]: {
      bottom: vars.space["2xs"],
      insetInlineEnd: vars.space["2xs"],
    },
  },
});

export const elementInTableWrapper = style({
  position: "relative",
  flex: "1",
  paddingInlineEnd: vars.space.m,
  minWidth: "0",
});
